import {CommonService} from '../../services/common.service';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {
  SuperMarketKeyAccountDialogComponent
} from './super-market-key-account-dialog/super-market-key-account-dialog.component';
import {
  UploadSuperMarketKeyAccountDialogComponent
} from './upload-super-market-key-account-dialog/upload-super-market-key-account-dialog.component';
import {ExportCsvService} from '../../services/export-csv.service';
import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'app-super-market-key-account',
  templateUrl: './super-market-key-account.component.html'
})
export class SuperMarketKeyAccountComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  models: any[];
  superMarketKeyAccount: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayPartColumns = ['key_account_name', 'sales_group_id', 'sales_group_name', 'payer_id'];
  loading: boolean;

  constructor(private commonService: CommonService,
              private exportCsvService: ExportCsvService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
    this.loading = false;
  }

  ngOnInit(): void {
    this.loading = true;
  }

  async ngAfterViewInit(): Promise<void> {
    await this.initModels();
    this.superMarketKeyAccount.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.superMarketKeyAccount.filter = filterValue.trim().toLowerCase();
  }

  browseFiles() {
    const dialog = this.matDialog.open(UploadSuperMarketKeyAccountDialogComponent, {});
    dialog.afterClosed().subscribe(async () => {
      await this.initModels();
    });
  }

  exportExcel() {
    const {data, columns} = this.formatExcelModel();
    this.exportCsvService.exportAsCustomExcelFile(data, 'Super Market Key Account', columns);
  }

  formatExcelModel() {
    const data = [];
    for (const record of this.superMarketKeyAccount.data) {
      const model = {
        key_account_name: record.key_account_name,
        sales_group_id: record.sales_group_id,
        sales_group_name: record.sales_group_name,
        payer_id: record.payer_id,
      };
      data.push(model);
    }

    const columns = [{
      key: 'key_account_name',
      label: 'Key Account',
    }, {
      key: 'sales_group_id',
      label: 'Κωδικός Δρομολογίου',
    }, {
      key: 'sales_group_name',
      label: 'Δρομολόγιο',
    }, {
      key: 'payer_id',
      label: 'Κωδικός Payer',
    }
    ];

    return {data, columns};
  }

  async initModels() {
    try {
      this.loading = true;
      this.models = await this.commonService.getSimpleList('super_market_key_account') as any[];
      this.superMarketKeyAccount = new MatTableDataSource<any>(this.models);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }

  async showKeyAccountDialog() {
    const dialog = this.matDialog.open(SuperMarketKeyAccountDialogComponent, {
      width: '450'
    });

    dialog.afterClosed().subscribe(async (result) => {
      let insertData;
      if (result) {
        insertData = {
          key_account_name: result.key_account_name,
          sales_group_id: result.sales_group_id,
          payer_id: result.payer_id
        };
        try {
          await this.commonService.insertObjectForAutomations('super_market_key_account', insertData);
          await this.initModels();
          this.toastMessagesService.toastInsertSuccess();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.error);
        }
      }
    });
  }
}
